import { useMemo } from 'react';

import type { IRecord } from '@gp/types/global';

export default function useSearchParams() {
  const searchParams = useMemo<IRecord<string>>(() => {
    const data = new URLSearchParams(location.search.substring(1));
    const result: IRecord<string> = {};

    data.forEach((value, key) => {
      try {
        result[key] = decodeURIComponent(value);
      } catch (e) {
        console.error(e);
        result[key] = value || '';
      }
    });

    return result;
  }, [location.search]);

  return searchParams;
}
